import Home from "./Pages/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Blog from "./Pages/Blog";
import MainLayout from "./Layouts/MainLayout";
import Error from "../../Components/Error";
import ShopApp from "../../Shop/ShopApp";
import Single from "../../Shop/Pages/Single";
import ScrollToTop from "../../utils/ScrollToTop";
import Weblog from "./Pages/Weblog";
import Post from "./Pages/Post";
import AboutUs from "./Pages/AboutUs";
import ContactUs from "./Pages/ContactUs";
import Error404 from "../../Components/Error404";

export default function Theme1(){
    return(
        <BrowserRouter>
            <ScrollToTop/>
            <Routes>
                <Route path="/" element={<MainLayout />} errorElement={<Error />}>
                    <Route index element={<Home />} />
                    <Route path="blog" element={<Weblog />} />
                    <Route path="post/:id" element={<Post />} />
                    <Route path="about" element={<AboutUs />} />
                    <Route path="contact" element={<ContactUs />} />
                    <Route path="*" element={<Error404 />} />
                </Route>
                <Route path="shop" element={<ShopApp />} errorElement={<Error />}/>
                <Route path="product/:id" element={<Single />} errorElement={<Error />}/>
                <Route path="*" element={<Error404 />} />
            </Routes>
        </BrowserRouter>         
    )
}